import React from 'react';
import Layout from 'shared/components/Layout/Layout';
import Post from './Post';
import HeaderNavy from '../../../../components/HeaderNavy/HeaderNavy';

function action() {
  return {
    title: 'Tutorfly for Schools',
    chunks: ['post-5'],
    component: (
      <Layout>
        <HeaderNavy
          title="Blog article"
          subtitle="Combatting Learning Loss with High-Dosage Tutoring"
          breadcrumb="Tutoring for Schools &gt; Blog &gt; Combatting Learning Loss with High-Dosage Tutoring"
          link="/schools#blog"
        />
        <Post />
      </Layout>
    ),
  };
}

export default action;
